import React from "react";

// seaborn-style colormap RdYlGn_r (green=low, red=high)
const RDYLGN_R_STOPS = [
  "#1a9850",
  "#91cf60",
  "#d9ef8b",
  "#ffffbf",
  "#fee08b",
  "#fc8d59",
  "#d73027",
];

const hexToRgb = (hex) => {
  if (typeof hex !== "string") return { r: 200, g: 200, b: 200 };
  const m = /^#?([a-fA-F0-9]{6})$/.exec(hex.trim());
  if (!m) return { r: 200, g: 200, b: 200 };
  const v = m[1];
  //   const v = hex.replace("#", "");
  return {
    r: parseInt(v.slice(0, 2), 16),
    g: parseInt(v.slice(2, 4), 16),
    b: parseInt(v.slice(4, 6), 16),
  };
};
const lerp = (a, b, t) => a + (b - a) * t;
const lerpColor = (c1, c2, t) => {
  const a = hexToRgb(c1),
    b = hexToRgb(c2);
  return `rgb(${Math.round(lerp(a.r, b.r, t))},${Math.round(
    lerp(a.g, b.g, t)
  )},${Math.round(lerp(a.b, b.b, t))})`;
};
const ramp = (t) => {
  const N = RDYLGN_R_STOPS.length - 1;
  const x = t * N;
  const i = Math.floor(x);
  return lerpColor(
    RDYLGN_R_STOPS[i],
    RDYLGN_R_STOPS[Math.min(i + 1, N)],
    x - i
  );
};

export default function HeatmapChart({ refData }) {
  const xLabels = ["% HIV Positivity", "% Linkage & Referral"];
  const yLabels = refData.map((d) => d.place);
  const data = refData.map((d) => [d.hiv_positivity, d.linkage_referral]);

  const minV = 0,
    maxV = 100;
  const rowHeight = 40; // taller row height
  const cellWidth = 400; // wider cells
  const heatmapHeight = yLabels.length * rowHeight;
  const legendSteps = [0, 20, 40, 60, 80, 100];

  return (
    <div className="card hptCard mt-4 border-0">
      <div className="card-body">
        <h6
          style={{
            fontWeight: "bold",
          }}
        >
          Percentage of HIV Positivity and Linkage Referral
        </h6>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "20px auto",
        }}
      >
        {/* Heatmap table */}
        <div>
          <table style={{ borderCollapse: "collapse" }}>
            <tbody>
              {yLabels.map((state, rowIdx) => (
                <tr key={rowIdx} style={{ height: rowHeight }}>
                  {/* State labels (Y-axis) */}
                  <td
                    style={{
                      padding: "6px 10px",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {state}
                  </td>

                  {/* Data cells */}
                  {data[rowIdx].map((val, colIdx) => {
                    const t = (val - minV) / (maxV - minV);
                    const color = ramp(t);
                    return (
                      <td
                        key={colIdx}
                        style={{
                          background: color,
                          width: cellWidth,
                          textAlign: "center",
                          border: "1px solid #ccc",
                          fontSize: 14,
                        }}
                      >
                        {val.toFixed(2)}%
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>

            {/* X-axis labels at bottom */}
            <tfoot>
              <tr style={{ height: 30 }}>
                <td></td>
                {xLabels.map((label, i) => (
                  <td
                    key={i}
                    style={{
                      textAlign: "center",
                      padding: "6px",
                      fontWeight: "bold",
                      width: cellWidth,
                    }}
                  >
                    {label}
                  </td>
                ))}
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Vertical color legend aligned with heatmap */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginLeft: "10px",
            position: "relative",
          }}
        >
          {/* Gradient bar */}
          <div
            style={{
              position: "relative",
              width: "16px",
              height: "100%", // match heatmap height
              background: "linear-gradient(to top,#1a9850, #ffffbf, #d73027)",
              border: "1px solid #ccc",
            }}
          >
            {legendSteps.map((step, i) => {
              const pos = (i / (legendSteps.length - 1)) * 100;
              return (
                <React.Fragment key={step}>
                  {/* Labels */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: `${pos}%`,
                      right: "-35px",
                      transform: "translateY(50%)",
                      fontSize: 12,
                    }}
                  >
                    {step}%
                  </div>

                  {/* Gridline across heatmap */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: `${pos}%`,
                      right: "0px", // extend into heatmap
                      width: "6px", // large width to cover heatmap fully
                      borderTop: "1px solid black",
                    }}
                  ></div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
